import { WHATSAPP_AUTO_LIVE } from "../content";
import { formatMxn } from "../mockData";
import { MockFigure } from "./frames";
import "./MiniVisuals.css";

/**
 * Dibujos pequeños de la franja de organizadores del inicio: pantallas de la
 * app reducidas a lo esencial, con datos de ejemplo del universo de
 * mockData.ts. Sin leyenda propia (la franja lleva una sola «Datos de
 * ejemplo» para los cuatro).
 */
export type MiniVisualKind = "payment" | "reminder" | "courts" | "formats";

export function MiniVisual({ kind }: { kind: MiniVisualKind }) {
  if (kind === "payment") return <PaymentChip />;
  if (kind === "reminder") return <ReminderBubble />;
  if (kind === "courts") return <CourtGridMini />;
  return <FormatTags />;
}

/** «Pago recibido · $850 ✓». */
export function PaymentChip() {
  return (
    <MockFigure label="Ejemplo: aviso de pago recibido por $850 con Mercado Pago" caption={false} className="mk-mini-figure">
      <div className="mk-mini mk-mini--payment">
        <span className="mk-mini__ok">✓</span>
        <span className="mk-mini__text">
          <strong>Pago recibido</strong>
          <small>Mariana Ortiz · Femenil 4.0</small>
        </span>
        <strong className="mk-mini__amount">{formatMxn(850)}</strong>
      </div>
    </MockFigure>
  );
}

/** Burbuja «Tu partido es mañana a las 10:00» con los canales del aviso. */
export function ReminderBubble() {
  const channels = WHATSAPP_AUTO_LIVE ? ["WhatsApp", "App"] : ["App"];
  return (
    <MockFigure
      label={`Ejemplo: recordatorio «Tu partido es mañana a las 10:00» ${WHATSAPP_AUTO_LIVE ? "por WhatsApp y en la app" : "en la app"}`}
      caption={false}
      className="mk-mini-figure"
    >
      <div className="mk-mini mk-mini--reminder">
        <div className="mk-mini__bubble">
          <span className="mk-mini__app">
            <i />
            Torneos123 · Rol de juego
          </span>
          <p>Tu partido es mañana a las 10:00</p>
        </div>
        <div className="mk-mini__channels">
          {channels.map((channel) => (
            <span key={channel}>{channel} ✓</span>
          ))}
        </div>
      </div>
    </MockFigure>
  );
}

type Cell = "busy" | "free" | "blocked" | "selected";

const COURT_ROWS: { time: string; cells: Cell[] }[] = [
  { time: "09:00", cells: ["busy", "busy", "busy"] },
  { time: "10:30", cells: ["busy", "free", "blocked"] },
  { time: "12:00", cells: ["selected", "busy", "free"] },
];

/** Cuadrícula de 3 canchas × 3 horarios: programado, libre y bloqueado. */
export function CourtGridMini() {
  return (
    <MockFigure label="Ejemplo: cuadrícula de 3 canchas y 3 horarios con partidos programados, horarios libres y una cancha bloqueada" caption={false} className="mk-mini-figure">
      <div className="mk-mini mk-mini--courts">
        <div className="mk-mini__grid">
          <span />
          <b>Cancha 1</b>
          <b>Cancha 2</b>
          <b>Cancha 3</b>
          {COURT_ROWS.map((row) => (
            <Row key={row.time} time={row.time} cells={row.cells} />
          ))}
        </div>
        <div className="mk-mini__legend">
          <span className="is-busy">Programado</span>
          <span className="is-free">Libre</span>
          <span className="is-blocked">Bloqueado</span>
        </div>
      </div>
    </MockFigure>
  );
}

function Row({ time, cells }: { time: string; cells: Cell[] }) {
  return (
    <>
      <b className="mk-mini__time">{time}</b>
      {cells.map((cell, index) => (
        <i key={index} className={`mk-mini__cell is-${cell}`} />
      ))}
    </>
  );
}

const FORMAT_TAGS = ["Grupos + liguilla", "Eliminación directa", "Escalera", "Dobles", "Por equipos"];
const SPORT_TAGS = ["Tenis", "Pádel", "Pickleball"];

/** Etiquetas de formatos y deportes. */
export function FormatTags() {
  return (
    <MockFigure label="Formatos: grupos con liguilla, eliminación directa, escalera, dobles y por equipos; tenis, pádel y pickleball" caption={false} className="mk-mini-figure">
      <div className="mk-mini mk-mini--formats">
        <div className="mk-mini__tags">
          {FORMAT_TAGS.map((tag, index) => (
            <span key={tag} className={index === 1 ? "is-on" : undefined}>
              {tag}
            </span>
          ))}
        </div>
        <div className="mk-mini__sports">
          {SPORT_TAGS.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
      </div>
    </MockFigure>
  );
}
